<template>
  <div class="pa-2">
    <v-card v-if="isRegistered">
      <v-card-title>
        <h2>مرحبا!</h2>
      </v-card-title>
      <v-card-text>
          <div>{{customerInfo.fullName}}</div>
      </v-card-text>
    </v-card>
    <v-card v-else max-width="620px" class="mx-auto">
      <v-img max-height="125" contain src="@/assets/logo.jpg"></v-img>
      <v-card-title>
        <h2>تسجيل الدخول</h2>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="username"
            prepend-icon="mdi-account-circle"
            label="الايميل"
          />
          <v-text-field
            v-model="password"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            label="كلمة السر"
          />
        </v-form>
        <v-alert v-if="showError" type="error">
          اسم المستخدم أو كلمة السر غير صحيحة
        </v-alert>
      </v-card-text>
      <v-card-actions justify-center>
        <v-btn @click="logIn" :loading="isLoggingIn" color="success" block
          >تسجيل الدخول</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LogInComponent",

  //********************** */
  props: {},

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    showPassword: false,
    showError: false,
    username: "",
    password: "",
    isLoggingIn: false,
  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isLoggedIn: "isLoggedIn",
      isRegistered: "isRegistered",
      customerInfo: "customerInfo"
    }),
    isLogInInfoValid: function () {
      return this.username !== "" && this.password !== "";
    },
  },

  //********************** */
  methods: {
    logIn: async function () {
      this.isLoggingIn = true;
      try {
        await this.$store.dispatch("Account/logIn", {
          userName: this.username,
          password: this.password,
        });
        this.$store.dispatch("loadToken");
        await this.$store.dispatch("Cart/loadCart");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoggingIn = false;
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>